import React from 'react'

/**
 * JuniorCardLoading Component
 * 
 * This component displays a placeholder loading UI for the JuniorCard component.
 * It renders an empty grid layout with a background color indicating a loading state.
 * 
 * @component
 * @memberof Components
 * @example
 * return (
 *   <JuniorCardLoading />
 * )
 */
const JuniorCardLoading = () => {

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '15px', height: '580px', overflowY: 'auto', backgroundColor: '#edeff2' }}>
        </div>
    )
}

export default JuniorCardLoading